import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-daily-diary',
  templateUrl: './daily-diary.component.html',
  styleUrls: ['./daily-diary.component.css']
})
export class DailyDiaryComponent implements OnInit {
  myForm: FormGroup;
  table: Array<any> = [];
  campusDropdown: Array<any> = [];
  cources: Array<any> = [];
  scheduls: Array<any> = [];
  courceId: any = '';
  isEdit: boolean = false;
  editData: any;
  labelName: any = {};
  headingName: any = {};
  workItemId: any;

  constructor(private fb: FormBuilder,private active : ActivatedRoute, private CommonService: CommonService, private toastr: ToastrService) {
    this.active.params.subscribe(res=>{
      this.workItemId = res.id
    })
    this.loadlabels();
    this.load();
    this.loadHeadings();

  }

  ngOnInit(): void {
    this.myForm = this.fb.group({
      campus_id: ['', Validators.required],
      class_id: ['', Validators.required],
      section_id: ['', Validators.required],
      daily_diary_date: ['', Validators.required]
    })
    this.loadCampusDropdown();
    this.getCourses();

  }
  activeSpinner() {
    this.CommonService.activateSpinner();
  }

  deactivateSpinner() {
    this.CommonService.deactivateSpinner()
  }

  loadlabels() {
    this.labelName = {};
    this.CommonService.getCall(`TenantRegistration/GetLabelValuesByTaskid/${this.workItemId}/${localStorage.getItem('TenantCode')}`).subscribe((res: any) => {
      this.labelName = res;
      console.log(res);
    })
  }

  loadHeadings() {
    this.headingName = {};
    this.CommonService.getCall(`EmsDynamicheadingLables/GetLabelValuesByTaskid/${this.workItemId}/${localStorage.getItem('TenantCode')}`).subscribe((res: any) => {
      this.headingName = res;
    })
  }

  load() {
    let payload = {
      "tnt_code": localStorage.getItem('TenantCode'),
      "ROLE_NAME":localStorage.getItem('RoleName'),
      "USER_ID":localStorage.getItem('UserId')
    }
    this.CommonService.postCall('DailyDiary/GetList', payload).subscribe((res: any) => {
      this.table = [];
      setTimeout(() => {
        this.table = res;
      }, 10);
    })
  }


  loadCampusDropdown() {
    this.campusDropdown = [];
    this.CommonService.postCall('EmsCampus/CampusDropDownList', { 'tnt_code': localStorage.getItem('TenantCode') }).subscribe((res: any) => {
      this.campusDropdown = res;
    })
  }
  getCourses() {
    this.cources = [];
    this.activeSpinner()
    this.CommonService.getAdminCourses().subscribe((res: any) => {
      this.cources = res;
      this.deactivateSpinner()
    }, e => {
      this.deactivateSpinner()
    })
  }

  courceChange(id) {
    this.scheduls = [];
    let data = {
      "CourseId": id
    }
    this.activeSpinner()
    this.CommonService.getAdminCourseSchedule(data).subscribe((res: any) => {
      this.deactivateSpinner()
      this.scheduls = res;
    }, e => { this.deactivateSpinner() })
  }



  onSubmit(Form: FormGroup) {
    let value: any = Form.value
    value.tnt_code = localStorage.getItem('TenantCode');
    value.created_by = localStorage.getItem('UserId');
    if (this.isEdit) {
      value.modified_by = localStorage.getItem('UserId');
      value['daily_diary_id'] = this.editData.daily_diary_id;
      this.CommonService.postCall('DailyDiary/Update', value).subscribe((res: any) => {
        this.load()
        this.toastr.success("Updated Successfully")
        document.getElementById('md_close').click();
      }, err => {
        this.toastr.warning(err.error ? err.error : "Not Updates")
      })
    }
    else {

      this.CommonService.postCall('DailyDiary/Create', value).subscribe((res: any) => {
        this.load();
        this.toastr.success(" Created Successfully");
        document.getElementById('md_close')?.click();
      }, err => {
        this.toastr.error(err.error ? err.error : 'Not created')

      })
    }
  }

  edit(dairyId) {
    this.editData = dairyId;
    this.isEdit = true;
    let payload = {
      "daily_diary_id": dairyId
    }
    this.CommonService.postCall('DailyDiary/Get', payload).subscribe((res: any) => {
      this.editData = res;
      this.courceChange(this.editData.class_id);
      setTimeout(() => {
        this.dataTransForm(res);
      }, 100);

    }), err => { }
  }
  dataTransForm(res) {
    let ctrls = this.myForm.controls;
    Object.keys(ctrls).map(key => {
      let ctrl = ctrls[key];
      ctrl.setValue(res[key])
    })


    ctrls['daily_diary_date'].setValue(moment(this.editData['daily_diary_date']).format('yyyy-MM-DD'));

  }
  close() {
    this.myForm.reset();
    this.courceChange(this.editData.class_id),
      this.isEdit = null;
    this.editData = {};

  }
}
